<template>
  <div>
    <main class="main">
      <nav aria-label="breadcrumb" class="breadcrumb-nav mb-3">
        <div class="container">
          <ol class="breadcrumb">
            <li class="breadcrumb-item">
              <router-link to="/dashboard">Home</router-link>
            </li>
            <li class="breadcrumb-item">
              <router-link to="/meeting">Meeting</router-link>
            </li>
            <li class="breadcrumb-item active" aria-current="page">Dettaglio</li>
          </ol>
        </div>
      </nav>

      <alert-component :alertType="'success'" :message="successMessage"></alert-component>
      <alert-component :alertType="'danger'" :message="error"></alert-component>
      <LoadedComponent :loading="loading" />

      <div class="page-content" v-if="!loading">

        <!-- Cover hero -->
        <div class="meeting-hero" v-if="meeting.cover">
          <img :src="meeting.cover.path" :alt="meeting.cover.name" class="meeting-cover-img" />
          <div class="meeting-hero-overlay">
            <div class="container">
              <h1 class="meeting-title-hero">{{ meeting.name }}</h1>
            </div>
          </div>
        </div>

        <div class="container">

          <!-- Titolo (solo se non c'è cover) -->
          <h4 class="text-center pt-3 pb-1" v-if="!meeting.cover">{{ meeting.name }}</h4>

          <!-- Descrizione -->
          <div class="text-center mt-2 mb-3" v-if="meeting.description">
            <p class="text-muted">{{ meeting.description }}</p>
          </div>

          <!-- Barra azioni owner -->
          <div class="meeting-actions d-flex flex-wrap justify-content-center mb-4" v-if="meeting.owner">
            <button type="button" class="btn btn-outline-primary btn-sm mx-1 mb-2"
              data-target="#add-invitations" data-toggle="modal">
              <i class="las la-users"></i> Aggiungi relatore
            </button>
            <router-link :to="'/meeting/edit/' + meeting.slug" class="btn btn-outline-secondary btn-sm mx-1 mb-2">
              <i class="las la-cog"></i> Modifica meeting
            </router-link>
            <button v-if="meeting.status == 'progress'"
              type="button" class="btn btn-danger btn-sm mx-1 mb-2" @click="closeCall">
              <i class="las la-stop-circle"></i> Chiudi call e registrazione
            </button>
            <button v-if="meeting.status == 'programming' || meeting.status == 'publish' || meeting.status == 'error'"
              type="button" class="btn btn-outline-danger btn-sm mx-1 mb-2"
              data-toggle="modal" data-target="#confirm-delete">
              <i class="las la-trash"></i> Annulla evento
            </button>
          </div>

          <div class="row">
            <div class="col-lg-9 pt-2">
              <article class="entry">
                <figure class="entry-media pb-3">
                  <div v-if="meeting.owner || meeting.invitations" class="text-center">
                    <a :href="domainApi + '/meeting/' + meeting.id + '/' + token"
                      class="btn btn-primary btn-lg px-5" target="_blank" id="enter_call">
                      <i class="las la-video mr-2"></i>Entra in call
                    </a>
                  </div>
                  <div v-else-if="meeting.partecipants">
                    <video-component :options="optionsVideo"></video-component>
                    <p class="text-muted mt-2 small">
                      La live avrà inizio 120 secondi dopo l'ingresso dell'organizzatore
                    </p>
                  </div>
                  <div v-if="meeting.owner" class="text-center mt-3">
                    <a :href="meeting.admin_zoom_url" class="btn btn-danger btn-lg px-5">
                      <i class="las la-film mr-2"></i>Modalità regia
                    </a>
                  </div>
                </figure>

                <div class="entry-body">
                  <div class="entry-meta text-muted small mb-3">
                    <span><i class="las la-user mr-1"></i>{{ meeting.author }}</span>
                    <span class="mx-2">|</span>
                    <span><i class="las la-calendar mr-1"></i>{{ meeting.datetime_start }}</span>
                    <span class="mx-2">|</span>
                    <span><i class="las la-comment mr-1"></i>{{ comments.length }} commenti</span>
                  </div>
                  <div class="entry-content mt-2">
                    <TestComponent :activity_id_params="meeting.activity_id"></TestComponent>
                  </div>
                </div>
              </article>
            </div>

            <aside class="col-lg-3">
              <div class="sidebar">
                <h3 class="widget-title">Commenti</h3>
                <CommentFormComponent
                  :activity_id="meeting.activity_id"
                  :successmessagecomment="successMessageComment"
                  @setSuccessMessage="setSuccessMessage"
                  :errormessagecomment="errorMessageComment"
                  @setErrorMessage="setErrorMessage"
                  :loadComments="loadComments"
                  :comment_permission="comment_permission">
                </CommentFormComponent>
                <CommentListComponent
                  :activity_id="meeting.activity_id"
                  :successmessagecomment="successMessageComment"
                  @setSuccessMessage="setSuccessMessage"
                  :comments="comments"
                  :loadComments="loadComments"
                  :comment_permission="comment_permission"
                  :model="'meeting'"
                  class="mt-4">
                </CommentListComponent>
              </div>
            </aside>
          </div>
        </div>
      </div>
    </main>

    <!-- Modal: conferma eliminazione -->
    <div class="modal fade" tabindex="-1" role="dialog" id="confirm-delete">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Conferma eliminazione</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close" id="close-modal-delete-meeting">
              <span aria-hidden="true"><i class="icon-close"></i></span>
            </button>
          </div>
          <div class="modal-body">
            <p>Sei sicuro di voler eliminare e annullare il meeting?</p>
          </div>
          <div class="modal-footer">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">Annulla</button>
            <button type="button" class="btn btn-outline-danger" @click="deleteMeeting">Elimina</button>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal: aggiungi relatori -->
    <div class="modal fade" tabindex="-1" role="dialog" id="add-invitations">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Aggiungi relatori</h5>
            <div class="alert alert-success mb-0 ml-2 py-1 px-2" v-if="successMessageInvitated">
              <span style="color: white; font-size: 0.875rem;">{{ successMessageInvitated }}</span>
            </div>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close" id="close-modal-invitations">
              <span aria-hidden="true"><i class="icon-close"></i></span>
            </button>
          </div>
          <div class="modal-body">
            <ul class="list-unstyled mb-0">
              <li v-for="(user, index) in usersAddInvitations" :key="user.id">
                <div class="icheck-wetasphalt mt-3">
                  <input type="checkbox" :id="'chb1-' + user.id" @click="addInvitations(user.id, index)" />
                  <label :for="'chb1-' + user.id">{{ user.name }} {{ user.lastname }}</label>
                </div>
              </li>
            </ul>
          </div>
          <div class="modal-footer"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import httpauth from "@/services/httpauth.js";
import { useAuth } from "@/stores/auth.js";
import httpservices from "@/services/httpservices.js";
import LoadedComponent from "@/components/LoadedComponent.vue";
import router from "@/router";
import VideoComponent from "@/components/VideoComponent.vue";
import CommentFormComponent from "@/components/CommentForm.vue";
import CommentListComponent from "@/components/CommentList.vue";
import AlertComponent from "@/components/AlertComponent.vue";
import TestComponent from "@/components/TestComponent.vue";

export default {
  name: "ShowMeeting",
  props: ["slug"],
  components: {
    LoadedComponent,
    VideoComponent,
    CommentFormComponent,
    CommentListComponent,
    AlertComponent,
    TestComponent,
  },
  data() {
    return {
      meeting: [],
      successMessage: "",
      error: "",
      comments: [],
      loading: true,
      optionsVideo: {},
      errorMessageComment: "",
      successMessageComment: "",
      comment_permission: false,
      usersAddInvitations: [],
      successMessageInvitated: "",
      domainApi: "",
      token: "",
    };
  },
  mounted() {
    const domain = window.location.hostname;
    switch (domain) {
      case "localhost":
        this.domainApi = "https://dev.gestione.neurohub.it";
        break;
      case "demo.neurohub.it":
        this.domainApi = "https://test.gestione.neurohub.it";
        break;
      case "neurohub.it":
      case "www.neurohub.it":
        this.domainApi = "https://gestione.neurohub.it";
        break;
    }
    this.token = localStorage.getItem("token");
    this.getMeeting();
    this.loadPermission();
  },

  methods: {
    async loadPermission() {
      await httpservices
        .checkPermission(0, "comments", "create_comment")
        .then((response) => {
          this.comment_permission = response.data.permission;
        })
        .catch((error) => {
          console.log(error);
        });
      await httpservices
        .checkPermission(1, "meeting", "")
        .then((response) => {
          this.permission = response.data.permission;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    setSuccessMessage(value) {
      this.successMessageComment = value;
    },
    setErrorMessage(value) {
      this.errorMessageComment = value;
    },
    async addInvitations(userId, index) {
      await httpauth
        .get("/meetings/add-invitations/" + userId + "/" + this.meeting.id)
        .then((response) => {
          this.successMessageInvitated = response.data.message;
          this.usersAddInvitations.splice(index, 1);
        })
        .catch((error) => {
          if (error.response.status == 401 && error.response.data.message == "Unauthenticated.") {
            const auth = useAuth();
            auth.clearToken();
            window.location.href = "/";
          }
          if (error.response.status == 401) {
            this.error = error.response.data.message;
          }
        });
    },
    async loadComments() {
      try {
        const response = await httpservices.loadComments(this.meeting.activity_id);
        this.comments = response.data.data;
        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },
    async deleteMeeting() {
      await httpauth
        .get("/meetings/delete/" + this.meeting.slug)
        .then((response) => {
          if (response.data.status == 1) {
            localStorage.setItem("messageSuccessMeeting", response.data.message);
            location.href = "/meeting";
            return;
          }
          localStorage.setItem("messageErrorMeeting", response.data.message);
          location.href = "/meeting";
        })
        .catch((error) => {
          if (error.response.status == 401 && error.response.data.message == "Unauthenticated.") {
            const auth = useAuth();
            auth.clearToken();
            window.location.href = "/";
          }
        });
    },
    async closeCall() {
      this.loading = true;
      await httpauth
        .get("/meetings/stop-register/" + this.meeting.slug)
        .then((response) => {
          this.loading = false;
          if (response.data.status == 1) {
            router.push("/meeting");
            return;
          }
          this.error = response.data.message;
        })
        .catch((error) => {
          this.loading = false;
          if (error.response.status == 401 && error.response.data.message == "Unauthenticated.") {
            const auth = useAuth();
            auth.clearToken();
            window.location.href = "/";
          }
          if (error.response.status == 401 || error.response.status == 404) {
            this.error = error.response.data.message;
          }
        });
    },
    async getMeeting() {
      await httpauth
        .get("/meetings/show/" + this.slug)
        .then((response) => {
          this.loading = false;
          if (response.data.data) {
            this.meeting = response.data.data;
            if (this.meeting.status == "programming" || this.meeting.status == "progress") {
              this.loadComments();
              this.getUsers(this.meeting.slug);
              if (this.meeting.owner) {
                this.getUsers(this.meeting.slug);
              }
              this.optionsVideo = this.getOptons(this.meeting.streaming_url);
              return;
            }
            router.push("meeting/registration/" + this.meeting.slug);
          }
          router.push("/meeting");
        })
        .catch((error) => {
          if (error.response.status == 401 && error.response.data.message == "Unauthenticated.") {
            const auth = useAuth();
            auth.clearToken();
            window.location.href = "/";
          }
        });
    },
    async getUsers(slug) {
      await httpauth
        .get("/meetings/get-all-invitated/" + slug)
        .then((response) => {
          this.usersAddInvitations = response.data.data;
        })
        .catch((error) => {
          if (error.response.status == 401 && error.response.data.message == "Unauthenticated.") {
            const auth = useAuth();
            auth.clearToken();
            window.location.href = "/";
          }
          if (error.response.status == 401 || error.response.status == 404) {
            this.error = error.response.data.message;
          }
        });
    },
    getOptons(path) {
      return {
        controls: true,
        autoplay: true,
        fluid: true,
        sources: [{ src: path, type: "video/mp4" }],
      };
    },
  },
};
</script>

<style scoped>
.meeting-hero {
  position: relative;
  width: 100%;
  height: 400px;
  background: #1a1a2e;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  margin-bottom: 0;
}

.meeting-cover-img {
  max-width: 100%;
  max-height: 400px;
  width: auto;
  height: auto;
  display: block;
  object-fit: contain;
}

.meeting-hero-overlay {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 2rem 0 1.5rem;
  background: linear-gradient(to top, rgba(0, 0, 0, 0.65) 0%, transparent 100%);
}

.meeting-title-hero {
  color: #fff;
  font-size: 2rem;
  font-weight: 700;
  text-shadow: 0 1px 4px rgba(0, 0, 0, 0.5);
  margin: 0;
}

.meeting-actions {
  gap: 0.5rem;
}

.entry-media {
  background-color: transparent;
}
</style>
